<template>
    <div class="mx-auto mt-5">
        <div id="header-identificacao" class="row bg-light mb-2">
            <div class="col-sm-12 col-md-6">
                <fieldset class="form-group">
                    <div role="group" class="bv-no-focus-ring">
                        <label for="cnpj">CNJ:</label>
                        <input id="cnpj" type="text" readonly="readonly" :value="cnj"
                            class="font-weight-bold form-control-plaintext">
                    </div>
                </fieldset>
            </div>
        </div>
        <b-row class="d-flex justify-content-between" >
            <b-col sm="6" md="4" v-show="false">
                <label style="font-weight: bold;" id="titularReceita">
                    Indique o titular da receita de honorárioss:
                    <span class="text-danger">*</span>
                    <i class="fas fa-info-circle text-info fa-12x ml-3" variant="info"
                       v-b-modal.modal-info-titular
                       v-b-popover.hover.top="'Clique aqui para saber mais sobre titular da receita de honorários'"></i>
                </label>
            </b-col>
            <b-col sm="6" md="8" v-show="false">
                <b-form-radio-group
                    v-model="filtros.titularReceita"
                    name="radio-titularReceita">
                    <b-form-radio value="0" @click.native="updateRadioTitularReceita(0)">1) FEPGE - Fundo Especial da PGE</b-form-radio>
                    <b-form-radio value="1" @click.native="updateRadioTitularReceita(1)">2) CES - Caixa Especial de Sucumbência</b-form-radio>
                </b-form-radio-group>
            </b-col>
            <b-col>
                <b-button
                        id="btnAnterior"
                        class="mr-2"
                        @click="$emit('prevTab')"
                        variant="secondary"
                        style="height: 40px;" >
                    <i class="fa fa-arrow-left"></i> Anterior
                </b-button>
                <CompBotaoExibirOcultarColuna
                        :fields="fields"
                        :showColunms="showColunms"
                        @toggleColuna="toggleColuna"/>
            </b-col>
            <b-col style="display: flex; justify-content: center;">
                <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage"
                              :total-rows="configTable.rows" size="sm" class="pl-3" style="padding: 0 !important;"
                              v-if="configTable.perPage != 'Todos'">
                </b-pagination>
            </b-col>
            <b-col class="text-right">
                <b-button class="ml-2 my-2" variant="secondary" @click="limparFiltros"
                          style="margin-right: 10px; height: 40px; padding: 0 0.75rem;">
                    <i class="fas <i fa-broom"></i> Limpar Filtros
                </b-button>
                <b-form-select v-model="configTable.perPage" :options="[10, 100, 500, 1000, 'Todos']" size="sm"
                               class="col-2" style="height: 40px;"></b-form-select>
                <b-button class="ml-2" id="btnProximaTabela"
                          @click="$emit('nextStep')"

                          variant="primary" style="height: 40px;">
                    Próxima
                    <i class="fa fa-arrow-right"></i>
                </b-button>
            </b-col>
        </b-row>

        <b-table :items="resultado"
                :fields="fields"
                striped
                small
                responsive="sm"
                :busy="configTable.load"
                show-empty
                hover
                bordered
                class="mb-0"
                head-variant="light">
            <div slot="table-busy" class="text-center text-primary my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong> Carregando...</strong>
            </div>
            <template slot="empty">
                <p class="my-auto">Nenhuma Requisição encontrada para o processo informado.</p>
            </template>
            <template v-slot:head(0)="{ item }">
                Requisição <i class="coluna-fixa filter" :class="!isEmpty(filtros.numeroRequisicao) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Requisição', 'mascara', '', '########', $event)"></i>
            </template>
            <template v-slot:cell(0)="{ item }">
                <p class="coluna-resize text-center">
                    <a href="#!" @click="abrirModalExtrato(item)">
                        {{ item.numeroRequisicao }}
                    </a>
                </p>
            </template>
            <template v-slot:head(1)="{ item }">
                Devedor <i class="coluna-fixa filter" :class="!isEmpty(filtros.contribuinte) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Devedor', 'texto', '', null, $event)"></i>
            </template>
            <template v-slot:cell(1)="{ item }">
                <p class="coluna-resize">
                    {{ item.devedor }}
                </p>
            </template>
            <template v-slot:head(2)="{ item }">
                Data de Geração <i class="coluna-fixa filter" :class="!isEmpty(filtros.dataEmissao) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Data de Geração', 'data', '', null, $event)"></i>
            </template>
            <template v-slot:cell(2)="{ item }">
                <p class="coluna-resize text-center">
                    {{ item.dataGeracao }}
                </p>
            </template>
            <template v-slot:head(3)="{ item }" class="testt">
                Tipo de Pagamento <i class="coluna-fixa filter" :class="!isEmpty(filtros.tipoPagamento) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Tipo de Pagamento', 'checkbox', dados.tiposPagamento, null, $event)"></i>
            </template>
            <template v-slot:cell(3)="{ item }">
                <p class="coluna-resize">
                    {{ item.tipoPagamento }}
                </p>
            </template>
            <template v-slot:head(4)="{ item }">
                Forma de Pagamento <i class="coluna-fixa filter" :class="!isEmpty(filtros.formaPagamento) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Forma de Pagamento', 'checkbox', dados.formasPagamento, null, $event)"></i>
            </template>
            <template v-slot:cell(4)="{ item }">
                <p class="coluna-resize">
                    {{ item.formaPagamento }}
                </p>
            </template>
            <template v-slot:head(5)="{ item }">
                Valor Pago (R$) <i class="coluna-fixa filter" :class="!isEmpty(filtros.valor) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Valor Pago (R$)', 'numerico', '', null, $event)"></i>
            </template>
            <template v-slot:cell(5)="{ item }">
                <p class="coluna-resize text-right" v-if="item.valor != null">
                    {{ item.valor | currency }}
                </p>
            </template>
            <template v-slot:head(6)="{ item }">
                Situação da Requisição
                <i class="fas fa-info-circle text-info fa-12x ml-3" variant="info"
                   v-b-modal.modal-info-situacao
                   v-b-popover.hover.top="'Clique aqui para saber mais sobre Situação da Requisição'"></i>
                <i class="coluna-fixa filter" :class="!isEmpty(filtros.situacao) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Situação da Requisição', 'checkbox', dados.statusRequisicao, null, $event)"></i>
            </template>
            <template v-slot:cell(6)="{ item }">
                <p class="coluna-resize" :style="'color: ' + item.cor">
                    {{ item.situacao }}
                </p>
            </template>
        </b-table>

        <b-row class="d-flex justify-content-between" style="margin-top: 10px;">
            <b-col class="col-md-5">
            </b-col>
            <b-col style="display: flex; justify-content: center;" class="col-md-3">
            </b-col>
            <b-col class="col-md-2 text-right">
                <div data-v-48ccbe7e="" class="input-group input-group-md mb-2">
                    <div data-v-48ccbe7e="" class="input-group-prepend">
                        <span class="input-group-text">
                            <b>Requisições encontradas:&nbsp; </b>
                            {{configTable.perPage != 'Todos' ? configTable.rows : resultado.length}}
                        </span>
                    </div>
                </div>
            </b-col>
        </b-row>

        <b-modal
                ref="modal-info-situacao"
                id="modal-info-situacao"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Tipos de Situação da Requisição"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p><span style="color: #ffa500"><strong>Aguardando Aprovação:</strong></span> requisição de honorários gerada por usuário do perfil administrativo (estagiário ou servidor) e aguardando aprovação por algum procurador.</p>
                    <p><span style="color: #ffa500"><strong>Aguardando Validação:</strong></span> requisição de honorários com a forma de pagamento por transferência bancária e aguardando validação pelo GOFS e pelo tesoureiro do FEPGE.</p>
                    <p><span style="color: #ffa500"><strong>Pendente:</strong></span> requisição de honorários do tipo de pagamento à vista aguardando a confirmação de pagamento do boleto único ou do tipo de pagamento parcelamento aguardando a confirmação de pagamento do boleto da primeira parcela.</p>
                    <p><span style="color: #ffa500"><strong>Em dia:</strong></span> requisição de honorários do tipo de pagamento parcelamento com todas as parcelas vencidas pagas e ainda com parcelas a vencer.</p>
                    <p><span style="color: #ffa500"><strong>Atrasada:</strong></span> requisição de honorários do tipo de pagamento parcelamento com uma ou duas parcelas vencidas.</p>
                    <p><span style="color: #ff2e17"><strong>Cancelada:</strong></span> requisição de honorários do tipo de pagamento à vista com boleto único vencido e não pago, do tipo de pagamento parcelamento com o boleto da primeira parcela vencido e não pago ou cancelado por ação do usuário.</p>
                    <p><span style="color: #ff2e17"><strong>Rescindida:</strong></span> requisição de honorários do tipo de pagamento parcelamento rescindido após o registro de pagamento de uma ou mais parcelas ou rescindido por ação do usuário após o registro de pagamento de uma ou mais parcelas.</p>
                    <p><span style="color: #0073c0"><strong>Quitada:</strong></span> requisição de honorários do tipo de pagamento à vista com confirmação de pagamento ou do tipo de pagamento parcelamento com confirmação de pagamento de todas as parcelas.</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="primary" @click="hide('modal-info')"> Fechar</b-button>
            </template>
        </b-modal>

        <b-modal
            ref="modal-info-titular"
            id="modal-info-titular"
            size="xl"
            :content-class="'shadow ' + getTheme"
            title="Indique o titular da receita de honorários"
            header-bg-variant="info"
            header-text-variant="white"
            v-show="false">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <ul>
                        <li>
                            <p>Com a opção “1) FEPGE - Fundo Especial da PGE” selecionada, será gerada uma Requisição de Honorários devidos ao FEPGE;</p>
                        </li>
                        <li>
                            <p>Com a opção “2) CES - Caixa Especial de Sucumbência” selecionada, será enviada comunicação à CES para a cobrança de honorários devidos à Caixa Especial de Sucumbência.</p>
                        </li>
                    </ul>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="primary" @click="hide('modal-info')"> Fechar</b-button>
            </template>
        </b-modal>

        <ExtratoHonorariosAcaoJudicial
                ref="extratoHonorariosAcaoJudicial"
                :loading="loading"
                @closeModal="(update) => { updated = update; closeModal(); }"
                @openFilterModal="openFilter" />
        <ExtratoComunicacaoTransferencia
                ref="extratoComunicacaoTransferencia"
                :loading="loading"
                @obterComunicacaoTransferencia="obterComunicacaoTransferencia"
                @closeModal="(update) => { updated = update; closeModal(); }"
            />
    </div>
</template>

<script>
    import axios from 'axios'
    import formatarMixins from '../../../mixins/formatarMixins';
    import CompBotaoExibirOcultarColuna from "../../shared/components/CompBotaoExibirOcultarColuna";
    import ExtratoHonorariosAcaoJudicial from "../../shared/components/ExtratoHonorariosAcaoJudicial";
    import ExtratoComunicacaoTransferencia from "../../shared/components/ExtratoComunicacaoTransferencia";

    export default {
    props: ['resultado', 'configTable', 'filtroComponente', 'filtros', 'loading', 'cnj', 'selecteds'],
    components: {CompBotaoExibirOcultarColuna, ExtratoHonorariosAcaoJudicial, ExtratoComunicacaoTransferencia},
    mixins: [ formatarMixins ],
    watch: {
        currentPage() {
            this.configTable.checkedAll = false;
            this.$emit('consultar');
        },
        perPage() {
            this.configTable.currentPage = 1;
            this.$emit('consultar');
        }
    },
    data() {
        return {
            updated: false,
            urlApi: null,
            token: null,
            distanceTop: null,
            tamanhoTopo: 60,
            tamanhoBotoes: null,
            fixed: false,
            showColunms: [],
            fields: [],
            dados: {
                formasPagamento: null,
                tiposPagamento: null,
                statusRequisicao: null,
            },
        }
    },
    computed: {
        currentPage() {
            return this.configTable.currentPage;
        },
        perPage() {
            return this.configTable.perPage;
        },
        getTheme () {
            return this.$store.getters.getTheme
        }
    },
    methods: {
        async obterColunasUsuario() {
            const funcionalidade = 'honorariosAcaoJudicial';

            this.configTable.load = true;
            axios.get(`${this.urlApi}/v1/funcionalidade/configuracao/${funcionalidade}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                response.data.forEach((field, i) => {
                    if (field.ativo) {
                        this.showColunms.push(i)
                    }
                    this.fields.push({
                        key: `${i}`,
                        label: `${field.descricao}`,
                        thClass: field.ativo ? '' : 'd-none', tdClass: field.ativo ? '' : 'd-none',
                        codColunaFuncionalidade: field.codColunaFuncionalidade,
                        codFuncionalidade: field.codFuncionalidade
                    })
                })
            }).catch((error) => {
                this.exibirErro(error)
            }).finally(() => {
                this.configTable.load = false;
            })
        },

        toggleColuna(i) {
            let ativo;
            if (this.showColunms.includes(i)) {
                this.showColunms.splice(this.showColunms.indexOf(i), 1);
                this.fields[i].thClass = 'd-none';
                this.fields[i].tdClass = 'd-none';
                ativo = false
            } else {
                this.showColunms.push(i);
                this.fields[i].thClass = '';
                this.fields[i].tdClass = '';
                ativo = true
            }

            this.atualizarConfiguracaoColunm(i, ativo)
        },

        async atualizarConfiguracaoColunm(i, ativo) {
            const json = {
                codFuncionalidade: this.fields[i].codFuncionalidade,
                codColunaFuncionalidade: this.fields[i].codColunaFuncionalidade,
                ativo,
            };
            axios.put(`${this.urlApi}/v1/funcionalidade/configuracao`, json, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).catch((error) => {
                this.exibirErro(error)
            })
        },

        async listarFormaPagamento() {
            axios.get(`${this.urlApi}/v1/receitasDiversas/listarFormaPagamento`, {
                headers: {
                    'Authorization': this.token
                }
            }).then(response => {
                this.dados.formasPagamento = response.data
            })
        },
        async listarTiposPagamento() {
            axios.get(`${this.urlApi}/v1/regrasPagamento/listarTiposPagamento`, {
                headers: {
                    'Authorization': this.token
                }
            }).then(response => {
                this.dados.tiposPagamento = response.data
            })
        },
        async listarStatusRequisicao() {
            axios.get(`${this.urlApi}/v1/pesquisas/listarStatusRequisicao`, {
                headers: {
                    'Authorization': this.token
                }
            }).then(response => {
                this.dados.statusRequisicao = response.data
            })
        },
        openFilter(campo, tipo, values, mask, event) {
            this.$emit('openFilterPopup', campo, tipo, values, mask, event);
        },
        abrirModalExtrato(item) {
            if(item.tabelaOrigem == 1) {
                this.$refs['extratoHonorariosAcaoJudicial'].abrirExtrato(item);
            } else if(item.tabelaOrigem == 2) {
                this.$refs['extratoComunicacaoTransferencia'].abrirExtrato(item);
            }
        },

        limparFiltros() {
            this.$emit('limparFiltros');
        },
        obterComunicacaoTransferencia(id, avancarDois) {
            this.$emit('obterComunicacaoTransferencia', id, avancarDois);
        },
        closeModal() {
            this.$emit('consultarComScroll', this.updated);
            this.updated = false;
        },

        onScroll(e) {
            var thColunas = document.getElementsByClassName("coluna-fixa")[0].parentElement.parentElement;
            var commandLine = document.getElementById("btnAnterior").parentElement.parentElement;

            commandLine.style.position = 'sticky';
            commandLine.style.top = '60px';
            commandLine.style.zIndex = 2;
            commandLine.classList.add("background-scroller");

            thColunas.style.position = 'sticky';
            thColunas.style.top = (59 + commandLine.offsetHeight) + 'px';
            thColunas.style.zIndex = 1;
        },
        updateRadioTitularReceita(value) {
            this.$emit("alterarTitularReceita", value);
        },
    },
    mounted() {
        this.urlApi = process.env.VUE_APP_ROOT_API;
        this.token = JSON.parse(this.$store.getters.getUser).access_token;
        this.filtros.titularReceita = 1;

        this.obterColunasUsuario();

        this.listarFormaPagamento();
        this.listarTiposPagamento();
        this.listarStatusRequisicao();

        window.addEventListener("scroll", this.onScroll);
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.onScroll)
    },

}
</script>

<style scoped>

.no-line {
    white-space: nowrap;
}

</style>
